import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-voting',
  templateUrl: `${environment.pageFolder}/voting-verification-pin.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/voting-verification-pin.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule]
})

export class VotingVerificationPinComponent implements OnInit {
  remainingTimeToUsePIN: any;
  remainingTimeToUsePINFormatted: string = "";
  pinExpired: boolean = false;
  errorMessage: string = "";

  constructor(private apiService: Services, private router: Router, private readonly errorMessageService: ErrorMessageService) {
    this.calculateRemainingTimeToUsePin();
    this.remainingTimeToUsePIN > 0 ? this.startCountdown() : this.pinExpired = true;
  }

  ngOnInit(): void {
    const loader = document.getElementById("loader-container")
    loader!.style.display = "none";
    
    if(!GlobalConstants.isAuth|| (localStorage.getItem("sentPin") !== "true")) { 
      this.router.navigate(['/izbori']);
    }

    document.addEventListener("visibilitychange", () => {
      //console.log(document.visibilityState);
      this.calculateRemainingTimeToUsePin();
    });
  }

  calculateRemainingTimeToUsePin() {
    let pinTimestamp = localStorage.getItem("pinTimestamp");
    if(pinTimestamp) {
      let expirationTime = new Date(pinTimestamp);
      expirationTime.setMinutes(expirationTime.getMinutes() + 15);
      let currentTime = new Date();
      let remainingTime = Math.max(0, expirationTime.getTime() - currentTime.getTime());
      this.remainingTimeToUsePIN = Math.floor(remainingTime / 1000);
    } else {
      this.remainingTimeToUsePIN = 0;
      this.pinExpired = true;
    }
  }

  onInputKeyPress(event: any, input: any) {  
    if (input.value.length > 0) {
      input.classList.add('filled');
    } else {
      input.classList.remove('filled');
    }

    if(this.errorMessage) {
      this.errorMessage = "";
    }

    /* if(input.name !== "number-1" && (event.inputType === "deleteContentBackward")) {
      input.previousSibling.focus();
    } */

    if (input.name !== "number-6" && event.inputType !== "deleteContentBackward") {
      input.nextSibling.focus();
    }
  }

  submitVerificationPIN() {
    let pin: string = "";
    let pinInputs: any = document.getElementsByClassName("form-control-verification-pin");
    for(let i = 0; i < pinInputs.length; i++) {
      pin += pinInputs[i].value;
    }

    if(pin.length === 6) {
      this.apiService.checkVerificationPIN(pin).subscribe({
        next: data => {
          let response:any = data;

          if(data.data === true) {
            localStorage.setItem("pinVerified", "true");
            localStorage.removeItem("sentPin");
            localStorage.removeItem("pinTimestamp");
            this.router.navigate(['/izbori/upload-oi']);
          } else if(data.data === false) {
            this.errorMessage = this.errorMessageService.getErrorMessage("invalidPIN");
          }
        }, error: error => {         
          if(error.status === 401) {
            //this.Services.refreshToken();
          }
        }
      })
    } else {
      this.errorMessage = "";
    }
  }

  startCountdown() {
    const countdownInterval = setInterval(() => {
      this.remainingTimeToUsePIN--;
      if (this.remainingTimeToUsePIN <= 0) {
        this.pinExpired = true;
        clearInterval(countdownInterval);
      } else {
        const minutes = Math.floor(this.remainingTimeToUsePIN / 60);
        const seconds = this.remainingTimeToUsePIN - minutes * 60;
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');
        this.remainingTimeToUsePINFormatted = formattedMinutes + ":" + formattedSeconds;
      }      
    }, 1000);
  }

  sendNewPIN() {
    this.apiService.sendVerificationPIN().subscribe({
      next: (data: any) => {
        localStorage.setItem('pinTimestamp', (new Date()).toString());
        this.pinExpired = false;
        this.remainingTimeToUsePIN = 900;
        this.startCountdown();
      }, error: (error: { status: number; }) => {         
        if(error.status === 401) {
          //this.Services.refreshToken();
        }
      }
    })    
  }
}